import React from 'react';
import { Link } from 'react-router-dom';
export default function FamilyPhysicians() {
  return (
    <>
      <div className='services-item container'>
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle mob-order-2 p-0'>
            <div className='services-item-content'>
              <h2>Family <span>Physicians</span></h2>          
              <p>Our family physicians are available for consultations from 10:00 AM to 08:00 PM, both in the clinic and at the comfort of your home.</p>
              <Link to="/contacts" className="btn theam-btn-m">Contact Us</Link>
            </div>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 mob-order-1 p-0'>
          <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/clinic-visit-01.png`} alt="Home Visits" />
          </div>
        </div>
      </div>
    </>
  );
}
